import Pagination from '@/vuex/modules/pagination'
import Usuario from '@/vuex/modules/usuario'
import Perfil from '@/vuex/modules/perfil'
import Sistema from '@/vuex/modules/sistema'
import Permissao from '@/vuex/modules/permissao'
import TokenEmail from '@/vuex/modules/token'
import Questionario from '@/vuex/modules/questionario'
import Resposta from '@/vuex/modules/resposta'
import Envio from '@/vuex/modules/envio'
import Mensagem from '@/vuex/modules/mensagem'
import Cidade from '@/vuex/modules/cidade'
import Estado from '@/vuex/modules/estado'

export default {
  modules: {
    usuario: Usuario,
    token: TokenEmail,
    pagination: Pagination,
    permissao: Permissao,
    perfil: Perfil,
    sistema: Sistema,
    questionario: Questionario,
    envio: Envio,
    mensagem: Mensagem,
    resposta: Resposta,
    cidade: Cidade,
    estado: Estado
  }
}



// WEBPACK FOOTER //
// ./src/vuex/store.js